import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Listen & diagnose",
    desc: "We start with your data and your customers — auditing every channel to find where growth is really hiding.",
  },
  {
    n: "02",
    title: "Design the strategy",
    desc: "A clear, prioritised roadmap. Positioning, messaging and a media plan mapped to the metrics that matter.",
  },
  {
    n: "03",
    title: "Build & launch",
    desc: "Creative, campaigns and content shipped fast — with rigorous tracking baked in from day one.",
  },
  {
    n: "04",
    title: "Optimise relentlessly",
    desc: "We test, learn and reinvest. Compounding gains, transparent reporting, and a partner invested in your numbers.",
  },
];

export default function Approach() {
  return (
    <section id="approach" className="py-24 md:py-32 border-b border-white/10 bg-surface">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-accent mb-6">The Approach</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-2xl leading-[1.02] mb-16">
            A method, not a guess.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-x-16">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={(i % 2) * 0.1}>
              <div className="flex gap-6 md:gap-10 py-8 border-t border-white/10">
                <span className="font-display text-5xl md:text-7xl text-transparent text-stroke-accent leading-none">
                  {c.n}
                </span>
                <div className="pt-1">
                  <h3 className="font-display text-2xl md:text-3xl mb-3">{c.title}</h3>
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed max-w-sm">
                    {c.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
